import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isModalOpen: false,
  isOnSubmitStep: false,
  organization: null,
  openedFrom: null
}

const slice = createSlice({ name: 'seatRequestsExperiment',
  initialState,
  reducers: {
    openSeatRequestModal: (state, { payload }) => {
      state.isModalOpen = true
      state.openedFrom = payload.openedFrom
    },
    closeSeatRequestModal: (state) => {
      state.isModalOpen = false
      state.isOnSubmitStep = false
      state.openedFrom = null
    },
    setToSubmitStep: (state, { payload }) => {
      state.isOnSubmitStep = true
      state.organization = payload
    },
    setToOrgListStep: (state) => {
      state.isOnSubmitStep = false
      state.organization = null
    }
  } })

export const { reducer, actions: {
  closeSeatRequestModal,
  openSeatRequestModal,
  setToOrgListStep,
  setToSubmitStep
} } = slice
